export default __webpack_public_path__ + "static/media/news3.96d3d206.jpeg";